import request from '@/utils/request'

// 查询店铺审核信息列表
export function listShopAudit(query) {
  return request({
    url: '/shop/shop/audit/list',
    method: 'get',
    params: query
  })
}

// 查询店铺审核信息详细
export function getShopAudit(id) {
  return request({
    url: '/shop/shop/audit/' + id,
    method: 'get'
  })
}

export function shopAuditVerify(data) {
  return request({
    url: '/shop/shop/audit/verify',
    method: 'post',
    data: data
  })
}

// 新增店铺审核信息
export function addShopAudit(data) {
  return request({
    url: '/shop/shop/audit',
    method: 'post',
    data: data
  })
}

// 修改店铺审核信息
export function updateShopAudit(data) {
  return request({
    url: '/shop/shop/audit',
    method: 'put',
    data: data
  })
}

// 删除店铺审核信息
export function delShopAudit(id) {
  return request({
    url: '/shop/shop/audit/' + id,
    method: 'delete'
  })
}
